import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.filter.js";
import QSelect from "../select/QSelect.js";
import QBtn from "../btn/QBtn.js";
import QIcon from "../icon/QIcon.js";
import cache from "../../utils/cache.js";
var staticClass = 'q-table__bottom row items-center';
export default {
  props: {
    hideBottom: Boolean,
    hideSelectedBanner: Boolean,
    hideNoData: Boolean,
    hidePagination: Boolean
  },
  computed: {
    navIcon: function navIcon() {
      var ico = [this.iconFirstPage || this.$q.iconSet.table.firstPage, this.iconPrevPage || this.$q.iconSet.table.prevPage, this.iconNextPage || this.$q.iconSet.table.nextPage, this.iconLastPage || this.$q.iconSet.table.lastPage];
      return this.$q.lang.rtl === true ? ico.reverse() : ico;
    }
  },
  methods: {
    __getBottomDiv: function __getBottomDiv(h) {
      if (this.hideBottom === true) {
        return;
      }

      if (this.nothingToDisplay === true) {
        if (this.hideNoData === true) {
          return;
        }

        var message = this.loading === true ? this.loadingLabel || this.$q.lang.table.loading : this.filter ? this.noResultsLabel || this.$q.lang.table.noResults : this.noDataLabel || this.$q.lang.table.noData;
        var noData = this.$scopedSlots['no-data'];
        var children = noData !== void 0 ? [noData({
          message: message,
          icon: this.$q.iconSet.table.warning,
          filter: this.filter
        })] : [h(QIcon, {
          staticClass: 'q-table__bottom-nodata-icon',
          props: {
            name: this.$q.iconSet.table.warning
          }
        }), message];
        return h('div', {
          staticClass: staticClass + ' q-table__bottom--nodata'
        }, children);
      }

      var bottom = this.$scopedSlots.bottom;

      if (bottom !== void 0) {
        return h('div', {
          staticClass: staticClass
        }, [bottom(this.marginalsScope)]);
      }

      var child = this.hideSelectedBanner !== true && this.hasSelectionMode === true && this.rowsSelectedNumber > 0 ? [h('div', {
        staticClass: 'q-table__control'
      }, [h('div', [(this.selectedRowsLabel || this.$q.lang.table.selectedRecords)(this.rowsSelectedNumber)])])] : [];

      if (this.hidePagination !== true) {
        return h('div', {
          staticClass: staticClass + ' justify-end'
        }, this.__getPaginationDiv(h, child));
      }

      if (child.length > 0) {
        return h('div', {
          staticClass: staticClass
        }, child);
      }
    },
    __getPaginationDiv: function __getPaginationDiv(h, child) {
      var _this = this;

      var control;
      var rowsPerPage = this.computedPagination.rowsPerPage,
          paginationLabel = this.paginationLabel || this.$q.lang.table.pagination,
          paginationSlot = this.$scopedSlots.pagination,
          hasOpts = this.rowsPerPageOptions.length > 1;
      child.push(h('div', {
        staticClass: 'q-table__separator col'
      }));

      if (hasOpts === true) {
        child.push(h('div', {
          staticClass: 'q-table__control'
        }, [h('span', {
          staticClass: 'q-table__bottom-item'
        }, [this.rowsPerPageLabel || this.$q.lang.table.recordsPerPage]), h(QSelect, {
          staticClass: 'q-table__select inline q-table__bottom-item',
          props: {
            color: this.color,
            value: rowsPerPage,
            options: this.computedRowsPerPageOptions,
            displayValue: rowsPerPage === 0 ? this.$q.lang.table.allRows : rowsPerPage,
            dark: this.isDark,
            borderless: true,
            dense: true,
            optionsDense: true,
            optionsCover: true
          },
          on: cache(this, 'pgSize', {
            input: function input(pag) {
              _this.setPagination({
                page: 1,
                rowsPerPage: pag.value
              });
            }
          })
        })]));
      }

      if (paginationSlot !== void 0) {
        control = paginationSlot(this.marginalsScope);
      } else {
        control = [h('span', rowsPerPage !== 0 ? {
          staticClass: 'q-table__bottom-item'
        } : {}, [rowsPerPage ? paginationLabel(this.firstRowIndex + 1, Math.min(this.lastRowIndex, this.computedRowsNumber), this.computedRowsNumber) : paginationLabel(1, this.filteredSortedRowsNumber, this.computedRowsNumber)])];

        if (rowsPerPage !== 0 && this.pagesNumber > 1) {
          var btnProps = {
            color: this.color,
            round: true,
            dense: true,
            flat: true
          };

          if (this.dense === true) {
            btnProps.size = 'sm';
          }

          this.pagesNumber > 2 && control.push(h(QBtn, {
            key: 'pgFirst',
            props: _objectSpread(_objectSpread({}, btnProps), {}, {
              icon: this.navIcon[0],
              disable: this.isFirstPage
            }),
            on: cache(this, 'pgFirst', {
              click: this.firstPage
            })
          }));
          control.push(h(QBtn, {
            key: 'pgPrev',
            props: _objectSpread(_objectSpread({}, btnProps), {}, {
              icon: this.navIcon[1],
              disable: this.isFirstPage
            }),
            on: cache(this, 'pgPrev', {
              click: this.prevPage
            })
          }), h(QBtn, {
            key: 'pgNext',
            props: _objectSpread(_objectSpread({}, btnProps), {}, {
              icon: this.navIcon[2],
              disable: this.isLastPage
            }),
            on: cache(this, 'pgNext', {
              click: this.nextPage
            })
          }));
          this.pagesNumber > 2 && control.push(h(QBtn, {
            key: 'pgLast',
            props: _objectSpread(_objectSpread({}, btnProps), {}, {
              icon: this.navIcon[3],
              disable: this.isLastPage
            }),
            on: cache(this, 'pgLast', {
              click: this.lastPage
            })
          }));
        }
      }

      child.push(h('div', {
        staticClass: 'q-table__control'
      }, control));
      return child;
    }
  }
};